export const actionMethodeOptions = [
  { value: 'GET', label: 'GET' },
  { value: 'POST', label: 'POST' },
  { value: 'PUT', label: 'PUT' },
  { value: 'PATCH', label: 'PATCH' },
  { value: 'DELETE', label: 'DELETE' },
];

export const rawBodyType = 'raw';

export const bodyTypeOptions = [
  { value: null, label: 'none' },
  { value: 'multipart/form-data', label: 'multipart/form-data' },
  { value: 'application/x-www-form-urlencoded', label: 'x-www-form-urlencoded' },
  { value: rawBodyType, label: 'raw / GraphQL' },
];

export enum ActionTabsEnum {
  Params = 'params',
  Headers = 'headers',
  Body = 'body',
}
